import React, { useState, useEffect } from "react";
import FeedBackService from "../../Api/FeedBackService";

const FeedBack = () => {
    const [publicFeedbacks, setPublicFeedbacks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const feedbackService = new FeedBackService();

    useEffect(() => {
        fetchPublicFeedbacks();
    }, []);

    const fetchPublicFeedbacks = async () => {
        try {
            const response = await feedbackService.GetAllPublicFeedBacks();
            if (response.data.status === "success") {
                setPublicFeedbacks(response.data.data);
            } else {
                setError("Failed to load public feedbacks");
            }
        } catch (err) {
            setError("Error loading public feedbacks");
            console.error("Error fetching public feedbacks:", err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="text-center p-5">Loading public feedbacks...</div>;
    }

    if (error) {
        return <div className="alert alert-danger text-center">{error}</div>;
    }

    return (
        <div id="feedback" className="rbt-testimonial-area bg-color-white ptb--100 overflow-hidden">
            <div className="container-fluid">
                <div className="row g-5 align-items-center">
                    <div className="col-xl-3">
                        <div className="section-title pl--100 pl_sm--30">
                            <h2 className="title">
                                What My Learners <span className="theme-gradient">Say</span>
                            </h2>
                            <p className="description mt--20">
                                Learning communicate to global world and build a bright future
                                with our histudy.
                            </p>
                            <div className="veiw-more-btn mt--20">
                                <a
                                    className="rbt-btn btn-gradient rbt-marquee-btn marquee-text-y"
                                    href="#"
                                >
                                    <span data-text="Learn More">Learn More</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-9">
                        <div className="overflow-hidden">
                            <div className="scroll-animation-wrapper pt--50 pb--30">
                                <div className="scroll-animation scroll-right-left">
                                    {publicFeedbacks.length > 0 ? (
                                        publicFeedbacks.slice(0, Math.ceil(publicFeedbacks.length / 2)).map((feedback) => (
                                            <div className="single-column-20" key={`feedback-top-${feedback.course.id}`}>
                                                <div className="rbt-testimonial-box">
                                                    <div className="inner">
                                                        <div className="clint-info-wrapper">
                                                            <div className="client-info">
                                                                <h5 className="title">{feedback.course.title}</h5>
                                                                <span>
                                                                    Average Rating: {parseFloat(feedback.average_rating).toFixed(1)} ({feedback.feedback_count} {feedback.feedback_count === 1 ? 'Review' : 'Reviews'})
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="rating mt--20">
                                                            {[...Array(5)].map((_, index) => (
                                                                <i
                                                                    key={index}
                                                                    className={`fa fa-star ${index < Math.round(parseFloat(feedback.average_rating)) ? 'text-warning' : ''}`}
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (publicFeedbacks.length === 0 && !loading && !error) && (
                                        <p>No public feedbacks available yet.</p>
                                    )}
                                </div>
                            </div>
                            <div className="scroll-animation-wrapper pb--50">
                                <div className="scroll-animation scroll-left-right">
                                    {publicFeedbacks.length > Math.ceil(publicFeedbacks.length / 2) ? (
                                        publicFeedbacks.slice(Math.ceil(publicFeedbacks.length / 2)).map((feedback) => (
                                            <div className="single-column-20" key={`feedback-bottom-${feedback.course.id}`}>
                                                <div className="rbt-testimonial-box">
                                                    <div className="inner">
                                                        <div className="clint-info-wrapper">
                                                            <div className="client-info">
                                                                <h5 className="title">{feedback.course.title}</h5>
                                                                <span>
                                                                    Average Rating: {parseFloat(feedback.average_rating).toFixed(1)} ({feedback.feedback_count} {feedback.feedback_count === 1 ? 'Review' : 'Reviews'})
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="rating mt--20">
                                                            {[...Array(5)].map((_, index) => (
                                                                <i
                                                                    key={index}
                                                                    className={`fa fa-star ${index < Math.round(parseFloat(feedback.average_rating)) ? 'text-warning' : ''}`}
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (null)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeedBack;
